import { render, staticRenderFns } from "./KnExpenseSubCategories.vue?vue&type=template&id=02a61db3"
import script from "./KnExpenseSubCategories.js?vue&type=script&lang=js&external"
export * from "./KnExpenseSubCategories.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports